/* ==========================================================================
   Maison — JavaScript del tema (sin dependencias)
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};
  var R = T.routes || {};

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };

  /* ------------------------------------------------------------------ */
  /* Avisos                                                              */
  /* ------------------------------------------------------------------ */
  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ------------------------------------------------------------------ */
  /* Cajones (menú y carrito)                                            */
  /* ------------------------------------------------------------------ */
  var lastFocus = null;

  function anyOverlayOpen() {
    return !!($('.drawer.is-open') || ($('[data-popup]') && !$('[data-popup]').hidden));
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(function () { drawer.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!anyOverlayOpen()) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------ */
  /* Búsqueda                                                            */
  /* ------------------------------------------------------------------ */
  function searchOverlay() { return $('[data-search-overlay]'); }

  function openSearch() {
    var overlay = searchOverlay();
    if (!overlay) return;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    var input = $('[data-search-input]', overlay);
    if (input) setTimeout(function () { input.focus(); }, 30);
  }

  function closeSearch() {
    var overlay = searchOverlay();
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
  }

  var searchTimer, searchController;

  function predictiveSearch(query) {
    var results = $('[data-search-results]');
    if (!results) return;
    if (searchController) searchController.abort();
    searchController = new AbortController();

    var url = R.predictiveSearch +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection&resources[limit]=4&resources[limit_scope]=each' +
      '&section_id=predictive-search';

    fetch(url, { signal: searchController.signal })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var node = parseHTML(html).querySelector('[data-predictive-results]');
        results.innerHTML = node ? node.outerHTML : '';
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.innerHTML = '';
      });
  }

  /* ------------------------------------------------------------------ */
  /* Carrito                                                             */
  /* ------------------------------------------------------------------ */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function renderCartDrawer(html) {
    var drawer = $('#CartDrawer');
    if (!drawer || !html) return;
    var doc = parseHTML(html);
    var fresh = doc.querySelector('#CartDrawer .drawer__panel');
    var panel = $('.drawer__panel', drawer);
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
  }

  function refreshCart() {
    var drawer = $('#CartDrawer');
    if (!drawer) return Promise.resolve();
    return fetch(R.cart + '?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (sections) { renderCartDrawer(sections['cart-drawer']); })
      .then(function () { return fetch(R.cartJson); })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(payload) {
    var isForm = payload instanceof FormData;
    var headers = { Accept: 'application/json' };
    var body;

    if (isForm) {
      payload.append('sections', 'cart-drawer');
      payload.append('sections_url', window.location.pathname);
      body = payload;
    } else {
      payload.sections = 'cart-drawer';
      payload.sections_url = window.location.pathname;
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }

    return fetch(R.cartAdd, { method: 'POST', headers: headers, body: body })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || S.error);
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderCartDrawer(data.sections['cart-drawer']);
        return fetch(R.cartJson).then(function (res) { return res.json(); }).then(function (cart) {
          updateCount(cart.item_count);
          return data;
        });
      })
      .then(function (data) {
        if (T.cartType === 'drawer' && $('#CartDrawer')) {
          openDrawer($('#CartDrawer'));
        } else if (T.cartType === 'page') {
          window.location.href = R.cart;
        } else {
          toast(S.added);
        }
        return data;
      });
  }

  function changeLine(line, quantity, context) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            toast(data.message || data.description || S.error);
            if (context !== 'page') refreshCart();
            return;
          }
          if (context === 'page') {
            window.location.reload();
            return;
          }
          if (data.sections && data.sections['cart-drawer']) renderCartDrawer(data.sections['cart-drawer']);
          updateCount(data.item_count);
        });
      })
      .catch(function () { toast(S.error); });
  }

  /* ------------------------------------------------------------------ */
  /* Producto: variantes y galería                                       */
  /* ------------------------------------------------------------------ */
  var variantToken = 0;

  function scrollToMedia(root, mediaId) {
    var main = $('[data-gallery-main]', root);
    var item = main && $('[data-media-id="' + mediaId + '"]', main);
    if (item) main.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  }

  function onVariantChange(input) {
    var section = input.closest('[data-product-section]');
    var jsonEl = section && $('[data-variants-json]', section);
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var selected = $$('.variants__option', section).map(function (fieldset) {
      var checked = $('.variants__input:checked', fieldset);
      return checked ? checked.value : null;
    });

    $$('[data-option-value]', section).forEach(function (span) {
      span.textContent = selected[parseInt(span.getAttribute('data-option-value'), 10) - 1] || '';
    });

    var variant = variants.filter(function (v) {
      var options = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return options[i] === val; });
    })[0];

    var submit = $('[data-add-to-cart-submit]', section);

    if (!variant) {
      if (submit) { submit.disabled = true; submit.textContent = S.unavailable; }
      return;
    }

    var idInput = $('[data-variant-id]', section);
    if (idInput) idInput.value = variant.id;

    try {
      window.history.replaceState(null, '', window.location.pathname + '?variant=' + variant.id);
    } catch (e) { /* sin historial */ }

    if (variant.featured_media && variant.featured_media.id) {
      scrollToMedia(section, variant.featured_media.id);
    }

    var token = ++variantToken;
    var url = section.getAttribute('data-product-url') + '?variant=' + variant.id +
      '&section_id=' + section.getAttribute('data-section-id');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (token !== variantToken) return;
        var doc = parseHTML(html);

        var newPrice = $('[data-price]', doc);
        var price = $('[data-price]', section);
        if (newPrice && price) price.innerHTML = newPrice.innerHTML;

        var newBuy = $('[data-buy-buttons]', doc);
        var buy = $('[data-buy-buttons]', section);
        if (newBuy && buy) {
          var qty = $('input[name="quantity"]', buy);
          var qtyValue = qty ? qty.value : '1';
          buy.innerHTML = newBuy.innerHTML;
          var newQty = $('input[name="quantity"]', buy);
          if (newQty) newQty.value = qtyValue;
        }
      })
      .catch(function () {});
  }

  function initGallery(gallery) {
    if (gallery.__init) return;
    gallery.__init = true;

    var main = $('[data-gallery-main]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    if (!main || !thumbs.length) return;

    main.addEventListener('scroll', function () {
      var index = Math.round(main.scrollLeft / (main.clientWidth || 1));
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* Carruseles                                                          */
  /* ------------------------------------------------------------------ */
  function initCarousel(carousel) {
    if (carousel.__init) return;
    carousel.__init = true;

    var track = $('[data-carousel-track]', carousel);
    var prev = $('[data-carousel-prev]', carousel);
    var next = $('[data-carousel-next]', carousel);
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initRecommendations(root) {
    $$('[data-recommendations][data-url]', root).forEach(function (el) {
      if (el.__loaded) return;
      el.__loaded = true;
      fetch(el.getAttribute('data-url'))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            $$('[data-carousel]', el).forEach(initCarousel);
          }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cabecera transparente                                               */
  /* ------------------------------------------------------------------ */
  var scrollBound = false;
  function initHeader() {
    var header = $('[data-header]');
    if (!header || header.getAttribute('data-overlay') !== 'true') return;
    if (scrollBound) return;
    scrollBound = true;
    var update = function () { header.classList.toggle('is-transparent', window.scrollY < 10); };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ */
  /* Ventana emergente de suscripción                                    */
  /* ------------------------------------------------------------------ */
  var POPUP_KEY = 'maison-popup-dismissed';

  function popupDismissed() {
    try {
      var ts = parseInt(window.localStorage.getItem(POPUP_KEY), 10);
      return ts && Date.now() - ts < 7 * 24 * 60 * 60 * 1000;
    } catch (e) { return false; }
  }

  function dismissPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    if (!anyOverlayOpen()) document.body.classList.remove('is-locked');
    try { window.localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) { /* sin almacenamiento */ }
  }

  function showPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  }

  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;

    if (popup.querySelector('.form-message--success')) {
      showPopup();
      try { window.localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) { /* noop */ }
      return;
    }
    if (popupDismissed()) return;
    if (window.Shopify && window.Shopify.designMode) return;
    setTimeout(function () {
      if (!anyOverlayOpen()) showPopup();
    }, T.popupDelay || 8000);
  }

  /* ------------------------------------------------------------------ */
  /* Eventos delegados                                                   */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var el;

    if ((el = target.closest('[data-open-menu]'))) {
      openDrawer($('#MenuDrawer'));
      return;
    }

    if ((el = target.closest('[data-close-drawer]'))) {
      closeDrawer(el.closest('.drawer'));
      return;
    }

    if ((el = target.closest('[data-cart-link]'))) {
      if (T.cartType === 'drawer' && $('#CartDrawer')) {
        event.preventDefault();
        openDrawer($('#CartDrawer'));
        refreshCart();
      }
      return;
    }

    if ((el = target.closest('[data-open-search]'))) {
      openSearch();
      return;
    }

    if (target.closest('[data-close-search]')) {
      closeSearch();
      return;
    }

    var overlay = searchOverlay();
    if (overlay && !overlay.hidden && !target.closest('[data-search-overlay]')) {
      closeSearch();
    }

    if ((el = target.closest('[data-popup-close]'))) {
      dismissPopup();
      return;
    }

    if ((el = target.closest('[data-add-to-cart]'))) {
      event.preventDefault();
      var variantId = el.getAttribute('data-variant-id');
      if (!variantId || el.disabled) return;
      var original = el.textContent;
      el.disabled = true;
      addToCart({ id: parseInt(variantId, 10), quantity: 1 })
        .catch(function (err) { toast(err.message || S.error); })
        .then(function () { el.disabled = false; el.textContent = original; });
      return;
    }

    if ((el = target.closest('[data-qty-minus], [data-qty-plus]'))) {
      var wrap = el.closest('[data-qty]');
      var input = $('.qty__input', wrap);
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var value = (parseInt(input.value, 10) || 0) + (el.hasAttribute('data-qty-plus') ? 1 : -1);
      if (value < min) value = min;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if ((el = target.closest('[data-remove-line]'))) {
      var ctx = el.closest('[data-cart-page]') ? 'page' : 'drawer';
      changeLine(parseInt(el.getAttribute('data-line'), 10), 0, ctx);
      return;
    }

    if ((el = target.closest('[data-toggle-filters]'))) {
      var panel = $('[data-filters-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        el.setAttribute('aria-expanded', String(!panel.hidden));
      }
      return;
    }

    if ((el = target.closest('[data-thumb]'))) {
      scrollToMedia(el.closest('[data-gallery]'), el.getAttribute('data-thumb'));
      return;
    }

    if ((el = target.closest('[data-gallery-prev], [data-gallery-next]'))) {
      var gallery = el.closest('[data-gallery]');
      var main = $('[data-gallery-main]', gallery);
      if (main) main.scrollBy({ left: (el.hasAttribute('data-gallery-next') ? 1 : -1) * main.clientWidth, behavior: 'smooth' });
      return;
    }

    if ((el = target.closest('[data-carousel-prev], [data-carousel-next]'))) {
      var carousel = el.closest('[data-carousel]');
      var track = $('[data-carousel-track]', carousel);
      if (track) track.scrollBy({ left: (el.hasAttribute('data-carousel-next') ? 1 : -1) * track.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (target.matches('[data-auto-submit]')) {
      var form = target.form || target.closest('form');
      if (form) {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
      return;
    }

    if (target.matches('[data-line-qty]')) {
      var context = target.closest('[data-cart-page]') ? 'page' : 'drawer';
      var quantity = Math.max(0, parseInt(target.value, 10) || 0);
      changeLine(parseInt(target.getAttribute('data-line'), 10), quantity, context);
      return;
    }

    if (target.matches('.variants__input')) {
      onVariantChange(target);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form.matches('[data-product-form]')) {
      event.preventDefault();
      var submit = $('[data-add-to-cart-submit]', form);
      var errorEl = $('[data-form-error]', form);
      if (submit && submit.disabled) return;

      var label = submit ? submit.textContent : '';
      if (submit) submit.disabled = true;
      if (errorEl) errorEl.hidden = true;

      addToCart(new FormData(form))
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message || S.error;
            errorEl.hidden = false;
          } else {
            toast(err.message || S.error);
          }
        })
        .then(function () {
          if (submit) { submit.disabled = false; submit.textContent = label; }
        });
      return;
    }

    if (form.matches('form[data-confirm]')) {
      if (!window.confirm(form.getAttribute('data-confirm'))) event.preventDefault();
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-search-input]')) return;
    var query = event.target.value.trim();
    clearTimeout(searchTimer);
    if (!query) {
      var results = $('[data-search-results]');
      if (results) results.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(function () { predictiveSearch(query); }, 250);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    var popup = $('[data-popup]');
    if (popup && !popup.hidden) dismissPopup();
  });

  /* ------------------------------------------------------------------ */
  /* Inicio                                                              */
  /* ------------------------------------------------------------------ */
  function init(root) {
    root = root || document;
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-gallery]', root).forEach(initGallery);
    initRecommendations(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initHeader();
    initPopup();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initHeader();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart();
  });
})();
